import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import GroupedMenu from './GroupedMenu';
import ClientProvider from './client';
export default createDemo(import.meta.url, GroupedMenu, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/menus/demos/grouped/GroupedMenu.tsx",
    "fileName": "GroupedMenu.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport ListSubheader from '@mui/material/ListSubheader';\nimport Menu from '@mui/material/Menu';\nimport MenuItem from '@mui/material/MenuItem';\nimport { styled } from '@mui/material/styles';\n\nconst StyledListHeader = styled(ListSubheader)({\n  backgroundImage: 'var(--Paper-overlay)',\n});\n\nexport default function GroupedMenu() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const id = React.useId();\n  const buttonId = `${id}-button`;\n  const menuId = `${id}-menu`;\n  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);\n  const open = Boolean(anchorEl);\n  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {\n    setAnchorEl(event.currentTarget);\n  };\n  const handleClose = () => {\n    setAnchorEl(null);\n  };\n\n  return (\n    <div>\n      <Button\n        id={buttonId}\n        aria-controls={open ? menuId : undefined}\n        aria-haspopup=\"true\"\n        aria-expanded={open}\n        onClick={handleClick}\n      >\n        Dashboard\n      </Button>\n      <Menu\n        id={menuId}\n        anchorEl={anchorEl}\n        open={open}\n        onClose={handleClose}\n        slotProps={{\n          list: {\n            'aria-labelledby': buttonId,\n            sx: {\n              py: 0,\n            },\n          },\n        }}\n      >\n        <StyledListHeader>Category 1</StyledListHeader>\n        <MenuItem onClick={handleClose}>Option 1</MenuItem>\n        <MenuItem onClick={handleClose}>Option 2</MenuItem>\n        <StyledListHeader>Category 2</StyledListHeader>\n        <MenuItem onClick={handleClose}>Option 3</MenuItem>\n        <MenuItem onClick={handleClose}>Option 4</MenuItem>\n      </Menu>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 59,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport ListSubheader from '@mui/material/ListSubheader';\nimport Menu from '@mui/material/Menu';\nimport MenuItem from '@mui/material/MenuItem';\nimport { styled } from '@mui/material/styles';\n\nconst StyledListHeader = styled(ListSubheader)({\n  backgroundImage: 'var(--Paper-overlay)',\n});\n\nexport default function GroupedMenu() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const id = React.useId();\n  const buttonId = `${id}-button`;\n  const menuId = `${id}-menu`;\n  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);\n  const open = Boolean(anchorEl);\n  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {\n    setAnchorEl(event.currentTarget);\n  };\n  const handleClose = () => {\n    setAnchorEl(null);\n  };\n\n  return (\n    <div>\n      <Button\n        id={buttonId}\n        aria-controls={open ? menuId : undefined}\n        aria-haspopup=\"true\"\n        aria-expanded={open}\n        onClick={handleClick}\n      >\n        Dashboard\n      </Button>\n      <Menu\n        id={menuId}\n        anchorEl={anchorEl}\n        open={open}\n        onClose={handleClose}\n        slotProps={{\n          list: {\n            'aria-labelledby': buttonId,\n            sx: {\n              py: 0,\n            },\n          },\n        }}\n      >\n        <StyledListHeader>Category 1</StyledListHeader>\n        <MenuItem onClick={handleClose}>Option 1</MenuItem>\n        <MenuItem onClick={handleClose}>Option 2</MenuItem>\n        <StyledListHeader>Category 2</StyledListHeader>\n        <MenuItem onClick={handleClose}>Option 3</MenuItem>\n        <MenuItem onClick={handleClose}>Option 4</MenuItem>\n      </Menu>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 59,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Button",
      "@mui/material/ListSubheader",
      "@mui/material/Menu",
      "@mui/material/MenuItem",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
